import React, { FC } from "react";

import { Avatar, AvatarProps } from "@mui/material";

import { purple } from "../theme/colors";
import { PomeriumIcon } from "./icons";

type UserAvatarProps = {
  user: {
    id?: string;
    photoUrl?: string;
  };
} & AvatarProps;

const UserAvatar: FC<UserAvatarProps> = ({ user, ...props }) => {
  if (!user?.id) {
    return (
      <Avatar sx={{ bgcolor: purple.main }} {...props}>
        <PomeriumIcon />
      </Avatar>
    );
  }

  if (!user?.photoUrl) {
    return <Avatar {...props} />;
  }

  return <Avatar src={user?.photoUrl} {...props} />;
};
export default UserAvatar;
